<template>
    <section class="block-wrapper carousel-section" @click="handleClicks">
        <div class="row">
            <div class="columns small-12 medium-5 large-4 large-offset-1 xxlarge-3 xxlarge-offset-2">
                <h2 class="carousel-title" v-text="data.title"></h2>
            </div>
            <div class="columns small-12 medium-7 large-5 xlarge-4 xlarge-offset-1">
                <span class="carousel-text" v-text="data.text"></span>
            </div>
        </div>

        <div class="row align-right carousel-navigation">
            <div class="columns small-12 medium-4 large-4">

            </div>
            <div class="columns small-12 medium-6 large-6">
                <button class="carouselNav prev" v-on:click="prevSlide"><i>d</i></button>
                <button class="carouselNav next" v-on:click="nextSlide"><i>e</i></button>
            </div>
        </div>
        <div class="row">
            <div class="columns small-12 large-12">
                <carousel :navigateTo="activeSlide" :scrollPerPage="true" :navigationEnabled="false" :loop="true" :perPageCustom="[[0, 1], [400, 1], [550, 2], [768, 3], [1300, 4]]"
                 :paginationEnabled="false">
                    <slide v-for="(group, groupIndex) in data.carousel_group" v-bind:key="group.id" v-bind:class="[{active: group.expanded}]">
                        <div class="slide-header">
                            <h1 v-if="group.carousel_group_title" v-text="group.carousel_group_title"></h1>
                            <div class="expand-content carouselNav small" v-on:click="expandContent(groupIndex)">
                                <i>j</i>
                            </div>
                        </div>
                        <transition name="swap" v-for="(item, index) in group.carousel_item" :key="'carousel-' + index">
                            <div v-if="item.active" v-bind:style="{ backgroundImage: 'url(' + item.image + ')' }" :class="{ 'active': item.active }"
                             class="single-slide-wrapper">
                                <transition name="slide-up">
                                    <div v-if="group.expanded" class="slide-expanded-content">
										<div class="expand-close small" v-on:click="expandContent(groupIndex)">
											<i class="ruter-ficon-close"></i>
										</div>
                                        <h2 v-text="item.title"></h2>
                                        <div v-html="item.text"></div>
                                        <div v-if="itemCounter(group.carousel_item) > 1">
                                            <button class="carouselNav prev small" v-on:click="previousItem(index, groupIndex)" @keyup.enter="previousItem(index, groupIndex)">
                                                <i>d</i>
                                            </button>
                                            <button class="carouselNav next small" v-on:click="nextItem(index, groupIndex)" @keyup.enter="nextItem(index, groupIndex)">
                                                <i>e</i>
                                            </button>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </transition>
                    </slide>
                </carousel>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    @import "../../styles/scss/component/carousel";
</style>

<script>
    import {
        Carousel,
        Slide
    } from 'vue-carousel';

    export default {
        props: ['data'],
        data: function () {
            return {
                activeSlide: 0
            }
        },
        watch: {
            activeSlide: function () {
                var pagesLength;
                var winWidth = window.innerWidth;

                if (winWidth >= 1100) {
                    pagesLength = Math.round(this.data.carousel_group.length / 4);
                }
                if (winWidth >= 768 && winWidth < 1100) {
                    pagesLength = Math.round(this.data.carousel_group.length / 3);
                }
                if (winWidth >= 550 && winWidth < 768) {
                    pagesLength = Math.round(this.data.carousel_group.length / 2);
                }
                if (winWidth >= 0 && winWidth < 550) {
                    pagesLength = Math.round(this.data.carousel_group.length / 1);
                }

                if (this.activeSlide == pagesLength) {
                    this.activeSlide = 0
                } else if (this.activeSlide < 0) {
                    this.activeSlide = pagesLength - 1
                }
            }
        },
        components: {
            Carousel,
            Slide
        },
        methods: {
            itemCounter: function (group) {
                return group.length;
            },
            updateItemActive(state, itemIndex, groupIndex) {
                this.data.carousel_group[groupIndex].carousel_item[itemIndex].active = state
            },
            toggleGroupExpanded(state, groupIndex) {
                for (var i = 0; i < this.data.carousel_group.length; i++) {
                    this.data.carousel_group[i].expanded = (i == groupIndex) ? !this.data.carousel_group[i].expanded : false;
                }
            },
            previousItem: function (itemIndex, groupIndex) {
                this.updateItemActive(false, itemIndex, groupIndex);
                itemIndex--;
                var prevItemIndex = (itemIndex === -1) ? this.data.carousel_group[groupIndex].carousel_item.length - 1 : itemIndex;
                this.updateItemActive(true, prevItemIndex, groupIndex);
            },
            nextItem: function (itemIndex, groupIndex) {
                this.updateItemActive(false, itemIndex, groupIndex);
                itemIndex++;
                var nextItemIndex = (itemIndex === this.data.carousel_group[groupIndex].carousel_item.length) ? 0 : itemIndex;
                this.updateItemActive(true, nextItemIndex, groupIndex);
            },
            prevSlide: function () {
                this.activeSlide--;
                // console.log('prevSlide & activeslide: : ' + this.activeSlide);
            },
            nextSlide: function () {
                this.activeSlide++;
                // console.log('nextSlide & activeslide: ' + this.activeSlide);
            },
            expandContent: function (groupIndex) {
                this.toggleGroupExpanded(true, groupIndex);
            },
            handleClicks($event) {
                this.$handleLinkClick($event, ".carousel-section .slide-expanded-content p a")
            }
        },
    }
</script>